// import { ChessSets } from "@chesshotel/constants";

export function preloadChessImages(chessSet: string) {
  const pieceTypes = [
    "wP",
    "wN",
    "wB",
    "wR",
    "wQ",
    "wK",
    "bP",
    "bN",
    "bB",
    "bR",
    "bQ",
    "bK",
  ];

  // Preload all piece images for the current chess set
  pieceTypes.forEach((piece) => {
    const img = new Image();
    img.src = `/images/pieces/${chessSet}/${piece}.svg`;
  });

  // Preload board image
  const boardImg = new Image();
  boardImg.src = `/images/board/${chessSet}.svg`;

  // Optionally preload other chess sets if they're commonly used
  // if (chessSet === ChessSets.CHESSHOTEL) {
  //   // Preload staunty as well since it might be used
  //   pieceTypes.forEach((piece) => {
  //     const img = new Image();
  //     img.src = `/images/pieces/staunty/${piece}.svg`;
  //   });
  //   const stauntyBoard = new Image();
  //   stauntyBoard.src = `/images/board/staunty.svg`;
  // }
}
